<ng-container [ngSwitch]="uiFramework">
  <div *ngSwitchCase="'ionic'">
    <ion-grid class="w-full ion-no-padding" fixed>
      <ng-container *ngIf="(initialInputMode === 0 || initialInputMode === 1) && inputTypeChannels.length === 0">
        <ion-row class="ion-align-items-center">
          <ion-col class="text-left pl-3 text-500" size="12">
            <ion-label class="body-2">
              {{ initialInputMode === 0 ? labels.parallelMode : labels.independentMode }}
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-align-items-center">
          <ion-col size="8">
            <ion-item
              class="radius-4 body-2 input-mode-item"
              lines="none">
              <ion-select
                class="w-full data-type-select input-type-select"
                interface="action-sheet"
                [value]="inputMode"
                (ionChange)="onInputModeChange($any($event))">
                <ion-select-option [value]="0">
                  {{ labels.parallelMode }}
                </ion-select-option>
                <ion-select-option [value]="1">
                  {{ labels.independentMode }}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
          <ion-col size="4">
            <ion-button
              class="ion-button-accent text-white radius-4 mt-1 save-button"
              size="small"
              [disabled]="!hasChanges"
              (click)="save()">
              {{ labels.save }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ng-container>
      <ng-container *ngIf="inputTypeChannels.length > 0">
        <ion-row class="ion-align-items-center">
          <ng-container *ngFor="let channel of inputTypeChannels; index as index">
            <ion-col size="12">
              <ion-label class="body-3 text-left text-400 text-grey-400">
                {{ labels.inputChannel }} - #{{ channel.id + 1 }}
              </ion-label>
              <ion-select
                class="w-full data-type-select input-type-select mt-1"
                interface="action-sheet"
                [value]="channel.input"
                (ionChange)="onInputTypeChannelValueChange(index, $any($event))">
                <ion-select-option [value]="0">
                  {{ labels.notUse }}
                </ion-select-option>
                <ion-select-option
                  *ngFor="let battery of availableBatteryInputTypes"
                  [value]="battery">
                  {{ battery | apply : getInputChannelName }}
                </ion-select-option>
                <ion-select-option
                  *ngFor="let pv of availablePvInputTypes"
                  [value]="pv">
                  {{ pv | apply : getInputChannelName }}
                </ion-select-option>
              </ion-select>
            </ion-col>
          </ng-container>
        </ion-row>
        <ion-row class="ion-justify-content-end">
          <ion-col class="ion-text-end">
            <ion-button
              class="ion-button-accent text-white radius-4 mt-1 save-button"
              size="small"
              [disabled]="!hasChanges"
              (click)="save()">
              {{ labels.save }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ng-container>
    </ion-grid>
  </div>

  <div *ngSwitchCase="'material'">
    <ng-container *ngIf="(initialInputMode === 0 || initialInputMode === 1) && inputTypeChannels.length === 0">
      <div class="fx-col p-4 border-1 border-grey-100 radius-4 bg-accent-100 w-fit">
        <div class="fx-row align-items-center mb-4">
          <div class="fx-col fx-flex-1">
            <div class="text-normal text-grey-400 text-capitalize">
              {{ initialInputMode === 0 ? labels.parallelMode : labels.independentMode }}
            </div>
          </div>
        </div>
        <div class="fx-row fx-gap-3 align-items-center mb-4">
          <div class="fx-col">
            <mat-form-field class="custom-mat-form-field custom-border-bottom">
              <mat-select
                [value]="inputMode"
                (selectionChange)="onInputModeChange($any({ detail: { value: $event.value } }))">
                <mat-option [value]="0">{{ labels.parallelMode }}</mat-option>
                <mat-option [value]="1">{{ labels.independentMode }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="fx-col">
            <button
              class="custom-mat-button-primary"
              mat-button
              [disabled]="!hasChanges"
              (click)="save()">
              {{ labels.save }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="inputTypeChannels.length > 0">
      <div class="fx-col p-4 border-1 border-grey-100 radius-4 bg-accent-100">
        <div class="custom-global-browser-setup">
          <ng-container *ngFor="let channel of inputTypeChannels; index as index">
            <div class="fx-col fx-gap-1">
              <span class="body-1 text-grey-400 text-capitalize text-500 text-left">
                {{ labels.inputChannel }} - #{{ channel.id + 1 }}
              </span>
              <mat-form-field class="custom-mat-form-field custom-border-bottom">
                <mat-select
                  [value]="channel.input"
                  (selectionChange)="onInputTypeChannelValueChange(index, $any({ detail: { value: $event.value } }))">
                  <mat-option [value]="0">{{ labels.notUse }}</mat-option>
                  <mat-option
                    *ngFor="let battery of availableBatteryInputTypes"
                    [value]="battery">
                    {{ getInputChannelName(battery) }}
                  </mat-option>
                  <mat-option
                    *ngFor="let pv of availablePvInputTypes"
                    [value]="pv">
                    {{ getInputChannelName(pv) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <div class="fx-row fx-justify-end mt-4">
          <button
            class="custom-mat-button-primary"
            mat-button
            [disabled]="!hasChanges"
            (click)="save()">
            {{ labels.save }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
